export default __webpack_public_path__ + "static/media/arms-outline.e5afa084.png";